import { createContext, useContext, useState, useCallback } from 'react'
import { AnimatePresence, motion } from 'framer-motion'

const ToastContext = createContext({ show: () => {} })

const typeStyles = {
  info:    { background: 'var(--pl-surface-2)', border: '0.5px solid var(--pl-border-2)', color: 'var(--pl-text)' },
  success: { background: 'var(--pl-accent-bg)', border: '0.5px solid var(--pl-accent-border)', color: 'var(--pl-terracota-700)' },
  error:   { background: 'var(--pl-error-bg)', border: '0.5px solid var(--pl-error)', color: 'var(--pl-error)' },
  warning: { background: 'var(--pl-warning-bg)', border: '0.5px solid var(--pl-warning-border)', color: 'var(--pl-warning)' }
}

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([])

  const show = useCallback(({ message, type = 'info', duration = 3000 }) => {
    const id = Date.now() + Math.random()
    setToasts(prev => [...prev, { id, message, type }])
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration)
  }, [])

  return (
    <ToastContext.Provider value={{ show }}>
      {children}
      <div style={{
        position: 'fixed',
        bottom: 'calc(80px + env(safe-area-inset-bottom, 0px))',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        pointerEvents: 'none',
        width: 'min(90%, 380px)'
      }}>
        <AnimatePresence>
          {toasts.map(t => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
              transition={{ duration: 0.2 }}
              style={{
                ...typeStyles[t.type] || typeStyles.info,
                padding: '12px 16px',
                borderRadius: 'var(--r-md)',
                fontFamily: 'var(--pl-font-sans)',
                fontSize: 14,
                pointerEvents: 'auto',
                boxShadow: '0 4px 24px rgba(0,0,0,0.5)'
              }}
            >
              {t.message}
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </ToastContext.Provider>
  )
}

export const useToast = () => useContext(ToastContext)
